export const NEW_USER = 'NEW_USER';
export const HAS_PASSWORD = 'HAS_PASSWORD';
export const WITHOUT_PASSWORD = 'WITHOUT_PASSWORD';
export const WITH_PASSCODE = 'WITH_PASSCODE';

// SCREENS
export const INSERT_PHONE_SCREEN = 'INSERT_PHONE_SCREEN';
export const CANCEL_REASON_PASSCODE_SCREEN = 'CANCEL_REASON_PASSCODE_SCREEN';
export const CHOOSE_SCREEN = 'CHOOSE_SCREEN';
export const OTHER_COUNTRIES_SEND_DISCLAIMER = 'OTHER_COUNTRIES_SEND_DISCLAIMER';
export const REGISTRATION_DISABLED_DISCLAIMER = 'REGISTRATION_DISABLED_DISCLAIMER';
export const WAITING_LIST = 'WAITING_LIST';
export const DISCLAIMER_SCREEN = 'DISCLAIMER_SCREEN';
export const INSERT_PASSWORD = 'INSERT_PASSWORD';
export const RESTORE_PASSWORD_SCREEN = 'RESTORE_PASSWORD';
export const BIRTHDAY_CHECK = 'BIRTHDAY_CHECK';
export const FROZEN_ACCOUNT = 'FROZEN_ACCOUNT';
export const FILL_PROFILE_SCREEN = 'FILL_PROFILE_SCREEN';
export const SMS_CONFIRMATION_SCREEN = 'SMS_CONFIRMATION_SCREEN';
export const PASSCODE_SCREEN = 'PASSCODE_SCREEN';
export const SIMPLE_REGISTRATION = 'SIMPLE_REGISTRATION';
export const PROMO_SCREEN = 'PROMO_SCREEN';
export const PRELOADER = 'PRELOADER';
export const FIELDS_SCREEN = 'FIELDS_SCREEN';
export const MIGRATION_PS_30_SCREEN = 'MIGRATION_PS_30_SCREEN';
